import FieldProto from "../../../proto/field-proto"
import FieldConfig from "../../../proto/field-config"
import FieldTotal_ViewSmall from "./render/view-small"
import FieldTotal_View from "./render/view"
import FieldNumber_AggregateCell from "../../number/render/aggregate/aggregate-cell"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"
import FieldNumber_BoardAggregate from "../../number/render/aggregate/board-aggregate"

// proto for all types of counters

export default class FieldTotal extends FieldProto {

    FIELD_DEFAULT_WIDTH = 100

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel                              = "total"
        this.icon                                   = 'i5-id'

        this.isSearchable                           = false
        this.hasCalculatedValues                    = true

        this.renderComponents.view                  = FieldTotal_View
        this.renderComponents.viewSmall             = FieldTotal_ViewSmall

        this.renderComponents.aggregateCell         = FieldNumber_AggregateCell
        this.renderComponents.boardAggregate        = FieldNumber_BoardAggregate
    }

    access(model: any): "read" | "write" | false {
        return 'read'
    }

    /*** DATA FUNCTIONS ***/

    sortValue(value:any) { return value ? value: 0; }

    searchValue(value:any) { return value ? value : ''; }

    getViewValue(model:any) {
        return model[this.fieldId];
    }

    /** AGGREGATE **/
    getAggregateOptions() {return [
        AggregateFunctionType.SUM,
        AggregateFunctionType.MIN,
        AggregateFunctionType.MAX,
        AggregateFunctionType.MEDIAN,
        AggregateFunctionType.AVERAGE
    ]}

    getDefaultAggregateFunction() {
        return AggregateFunctionType.SUM
    }
}
